import { LoadingButton } from "@mui/lab";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "../../Utils/RoutePath";
import { Button } from "@mui/material";

interface IformBuilder {
  onClick: () => void;
}

const Formbuilder = (props: IformBuilder) => {
  let navigate = useNavigate();

  const handleClick = () => {
    props.onClick();
  };

  return (
    <div className="justify-content-end">
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        startIcon={<EditIcon />}
      >
        Modifica
      </Button>
    </div>
  );
};

export default Formbuilder;
